module.exports = __webpack_public_path__ + "static/media/login-client.72f314eb.jpg";